import type SymbolStyleTypeUtil from "./SymbolStyleTypeUtil";

export default class SymbolBadgeStyleTypeUtil {
    private symbolStyleTypeUtil: SymbolStyleTypeUtil;

    constructor(symbolStyleTypeUtil: SymbolStyleTypeUtil) {
        this.symbolStyleTypeUtil = symbolStyleTypeUtil;
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    hasDirect(style): boolean {
        return false
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    hasOverlays(style): boolean {
        return true
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getPaddingPx(style): number[] {
        return this.symbolStyleTypeUtil.getPaddingPx(style.symbol);
    }
}
